"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  'Before Text': {
    kind: 'Text',
    props: {
      display: 'inline-block',
      children: 'The'
    }
  },
  'After Text': {
    kind: 'Text',
    props: {
      display: 'inline-block',
      children: 'website builder!'
    }
  },
  'Looped Text': {
    kind: 'Text',
    props: {
      display: 'inline-block',
      color: '--primary'
    }
  }
};
exports["default"] = _default;